/**
 * Plantillas base para emails RRHH (v0.2.2).
 * Variables: {{employee_name}}, {{company_name}}, {{document_name}}, {{due_date}},
 * {{leave_dates}}, {{manager_name}}, {{course_name}}, {{survey_link}}
 */

export const RRHH_EMAIL_DEMO_VARS = {
  employee_name: 'Ana Martínez',
  manager_name: 'Lucía Fernández',
  company_name: 'Spectra Metrics',
  document_name: 'Contrato laboral',
  due_date: '2026-02-28',
  leave_dates: '12/03/2026 — 20/03/2026',
  course_name: 'Seguridad de la información',
  survey_link: 'https://portal.spectra-metrics.com/encuestas/clima-demo',
};

export function applyRrhhTemplateVars(text, vars = RRHH_EMAIL_DEMO_VARS) {
  if (!text || typeof text !== 'string') return '';
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    const v = vars[key];
    return v != null && v !== '' ? String(v) : `{{${key}}}`;
  });
}

/** @type {Record<string, { subject: string; html: string; text: string }>} */
export const RRHH_TEMPLATE_DEFAULTS = {
  tpl_welcome: {
    subject: 'Bienvenida a {{company_name}}',
    html: '<p>Hola {{employee_name}},</p><p>Te damos la bienvenida a <strong>{{company_name}}</strong>. Tu manager de referencia es {{manager_name}}.</p><p>Saludos,<br/>RRHH</p>',
    text: 'Hola {{employee_name}}, te damos la bienvenida a {{company_name}}. Tu manager: {{manager_name}}.',
  },
  tpl_docs_pending: {
    subject: 'Documentación pendiente — {{company_name}}',
    html: '<p>Hola {{employee_name}},</p><p>Registramos pendiente el documento <strong>{{document_name}}</strong> con fecha límite <strong>{{due_date}}</strong>.</p><p>Podés cargarlo en el portal de legajo.</p>',
    text: 'Hola {{employee_name}}, pendiente {{document_name}} hasta {{due_date}}.',
  },
  tpl_doc_expired: {
    subject: 'Documento vencido — acción requerida',
    html: '<p>Hola {{employee_name}},</p><p>El documento <strong>{{document_name}}</strong> figura vencido al {{due_date}}. Por favor contactá a RRHH para regularizar.</p>',
    text: 'Hola {{employee_name}}, documento vencido: {{document_name}} ({{due_date}}).',
  },
  tpl_leave_ok: {
    subject: 'Tu licencia fue aprobada',
    html: '<p>Hola {{employee_name}},</p><p>Tu licencia para el período <strong>{{leave_dates}}</strong> fue <strong>aprobada</strong>.</p>',
    text: 'Hola {{employee_name}}, licencia aprobada: {{leave_dates}}.',
  },
  tpl_leave_rej: {
    subject: 'Actualización sobre tu solicitud de licencia',
    html: '<p>Hola {{employee_name}},</p><p>Lamentablemente no pudimos aprobar tu licencia solicitada para <strong>{{leave_dates}}</strong>. Contactá a {{manager_name}} para más detalle.</p>',
    text: 'Hola {{employee_name}}, tu licencia {{leave_dates}} no pudo aprobarse. Consultá con {{manager_name}}.',
  },
  tpl_exp_ok: {
    subject: 'Rendición de gastos aprobada',
    html: '<p>Hola {{employee_name}},</p><p>Tu rendición de gastos fue <strong>aprobada</strong>. Gracias por la gestión.</p>',
    text: 'Hola {{employee_name}}, tu gasto fue aprobado.',
  },
  tpl_exp_rej: {
    subject: 'Observaciones sobre tu rendición',
    html: '<p>Hola {{employee_name}},</p><p>Tu rendición requiere ajustes. Revisá los comentarios en el portal de gastos.</p>',
    text: 'Hola {{employee_name}}, tu rendición requiere ajustes.',
  },
  tpl_eval_pending: {
    subject: 'Evaluación de desempeño pendiente',
    html: '<p>Hola {{employee_name}},</p><p>Tenés una evaluación pendiente con {{manager_name}}. Completá el formulario en el portal.</p>',
    text: 'Hola {{employee_name}}, evaluación pendiente con {{manager_name}}.',
  },
  tpl_training: {
    subject: 'Capacitación asignada: {{course_name}}',
    html: '<p>Hola {{employee_name}},</p><p>Se te asignó el curso <strong>{{course_name}}</strong>. Ingresá al portal para iniciar.</p>',
    text: 'Hola {{employee_name}}, curso asignado: {{course_name}}.',
  },
  tpl_climate_survey: {
    subject: 'Encuesta de clima — {{company_name}}',
    html: '<p>Hola {{employee_name}},</p><p>Participá en la encuesta de clima: <a href="{{survey_link}}">{{survey_link}}</a></p>',
    text: 'Hola {{employee_name}}, encuesta de clima: {{survey_link}}',
  },
  tpl_urgent_comms: {
    subject: 'Comunicado urgente — RRHH',
    html: '<p>Hola {{employee_name}},</p><p><strong>RRHH</strong> de {{company_name}} necesita tu atención sobre un tema urgente. Respondé a este correo o contactá a tu manager {{manager_name}}.</p>',
    text: 'Hola {{employee_name}}, comunicado urgente de RRHH en {{company_name}}.',
  },
};

export const TEMPLATE_KEY_TO_EMAIL_TYPE = {
  tpl_welcome: 'welcome',
  tpl_docs_pending: 'docs_pending',
  tpl_doc_expired: 'doc_expired',
  tpl_leave_ok: 'leave_approved',
  tpl_leave_rej: 'leave_rejected',
  tpl_exp_ok: 'expense_approved',
  tpl_exp_rej: 'expense_rejected',
  tpl_eval_pending: 'eval_pending',
  tpl_training: 'training_assigned',
  tpl_climate_survey: 'climate_survey',
  tpl_urgent_comms: 'general_comms',
};
